import { jsx as _jsx } from "preact/jsx-runtime";
import Styles from './styles';
const Tooltip = (props) => {
    const { step, tooltipProps } = props;
    return (_jsx(Styles.Wrapper, { ...tooltipProps, role: "tooltip", children: _jsx("div", { dangerouslySetInnerHTML: { __html: step.content } }) }));
};
export default Tooltip;
